module.exports = __webpack_public_path__ + "media/images/tokyo_02-0d8a219ab14a8e5a78917461f2146c83.jpg";